import React from "react";
import ProfileLayout from "../../components/layout/ProfileLayout";
import BookingHome from "./components/BookingHome";

const BookingSection = () => {
  return (
    <ProfileLayout>
      <BookingHome />
    </ProfileLayout>
  );
};

export default BookingSection;
